import useCommonMetaObjectQuery from "@repo/shopifyV2/queries/useMetaObjectQuery";

import useLanguage from "@hooks/useLanguage";

import { useLayoutStore } from "@store/layout";

export default function useMetaObjects() {
  const { lang } = useLanguage();
  const { openToast } = useLayoutStore();

  return useCommonMetaObjectQuery({ lang, openToast });
}
